import { AppConfig } from 'AppConfig';
import axios from 'axios';

/**
 * Fetches the set of valid Person IDs for the given filter context from the backend.
 * The backend queries VDS and returns the full set; the frontend does intersection locally.
 *
 * @param {object} params
 * @param {string} params.tenantCd - The tenant code
 * @param {string} params.dateBasis - 'paid' or 'incurred'
 * @param {string} [params.currentStart] - Current period start (MM/dd/yyyy)
 * @param {string} [params.currentEnd] - Current period end (MM/dd/yyyy)
 * @param {string} [params.priorStart] - Prior period start (MM/dd/yyyy)
 * @param {string} [params.priorEnd] - Prior period end (MM/dd/yyyy)
 * @param {string[]} [params.division] - Selected divisions
 * @param {string[]} [params.plan] - Selected plans
 * @returns {Promise<Set<string>|null>} Set of valid Person IDs, or null on failure
 */
export const fetchValidPersonIds = async ({
  tenantCd,
  dateBasis,
  currentStart,
  currentEnd,
  priorStart,
  priorEnd,
  division,
  plan,
}) => {
  if (!tenantCd) {
    return null;
  }

  const payload = {
    tenantCd,
    dateBasis,
    ...(currentStart ? { currentStart } : {}),
    ...(currentEnd ? { currentEnd } : {}),
    ...(priorStart ? { priorStart } : {}),
    ...(priorEnd ? { priorEnd } : {}),
    ...(division?.length ? { division } : {}),
    ...(plan?.length ? { plan } : {}),
  };

  const response = await axios.post(
    AppConfig.FO_INITIAL_URL + '/person-id/valid-ids',
    payload,
    { hideSpinner: true }
  );

  const personIds = response?.data?.personIds;
  if (Array.isArray(personIds)) {
    return new Set(personIds);
  }

  return null;
};
